import { useTranslate } from '@festina-life/ui/hooks'
import { Typography } from '@festina-life/ui/structure'

export const NoRolesScreen = () => {
  const translate = useTranslate()

  const roles = [
    {
      name: translate('noRolesScreen.role.viewer.name'),
      description: translate('noRolesScreen.role.viewer.description'),
    },
    {
      name: translate('noRolesScreen.role.editor.name'),
      description: translate('noRolesScreen.role.editor.description'),
    },
    {
      name: translate('noRolesScreen.role.admin.name'),
      description: translate('noRolesScreen.role.admin.description'),
    },
  ]

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div className="max-w-lg space-y-6 p-8">
        <Typography size="2xl" intensity="primary" as="h1">
          {translate('noRolesScreen.heading')}
        </Typography>
        <Typography as="p">{translate('noRolesScreen.body')}</Typography>
        <ul className="space-y-4">
          {roles.map(({ name, description }) => (
            <li key={name}>
              <Typography as="span" intensity="primary">
                {name}
              </Typography>
              <Typography as="span" intensity="secondary">
                {' - '}
                {description}
              </Typography>
            </li>
          ))}
        </ul>
        <Typography as="p" intensity="secondary">
          {translate('noRolesScreen.contactSupport')}
        </Typography>
      </div>
    </div>
  )
}
